import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminLogin = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form.username, form.password);
      navigate('/admin');
    } catch {
      setError('Invalid credentials. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, var(--forest) 0%, #1A2F2A 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }}>
      <div style={{ 
        background: 'white', width: '100%', maxWidth: 440,
        padding: '48px', boxShadow: 'var(--shadow-lg)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ 
            fontFamily: 'Cormorant Garamond, serif', fontSize: '1.8rem', 
            fontWeight: 700, color: 'var(--forest)', marginBottom: 4
          }}>
            The Village <span style={{ color: 'var(--gold)' }}>Investors</span>
          </div>
          <p style={{ color: 'var(--warm-gray)', fontSize: '0.88rem' }}>Admin Portal</p>
        </div>

        {error && (
          <div style={{ 
            padding: '12px 16px', background: '#FFEBEE', color: '#C62828',
            marginBottom: 20, borderLeft: '4px solid #F44336', fontSize: '0.88rem'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input 
              type="text" 
              value={form.username}
              onChange={e => setForm({...form, username: e.target.value})}
              placeholder="admin" 
              required 
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              value={form.password}
              onChange={e => setForm({...form, password: e.target.value})}
              placeholder="••••••••" 
              required 
            />
          </div>
          <button 
            type="submit" 
            className="btn-gold" 
            style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In →'}
          </button>
        </form>

        <div style={{ marginTop: 24, padding: '16px', background: 'var(--cream)', borderRadius: '2px' }}>
          <p style={{ fontSize: '0.78rem', color: 'var(--warm-gray)', marginBottom: 4 }}>
            <strong>First time?</strong> Set up your admin account at:
          </p>
          <code style={{ fontSize: '0.78rem', color: 'var(--forest)' }}>POST /api/auth/setup</code>
          <p style={{ fontSize: '0.75rem', color: 'var(--warm-gray)', marginTop: 4 }}>
            See README.md for setup instructions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
